<div class="modal-content request-permission">
  <div class="modal-body">
    <app-status #status></app-status>
    <form *ngIf="!status.visible" [formGroup]="formulario" (submit)="request($event)">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <span class="input-group-text">@</span>
        </div>
        <select class="form-control" placeholder="Tipo" formControlName="username">
          <option *ngFor="let user of users" [value]="user.email">{{ optionDesc(user) }}</option>
        </select>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="fa fa-lock"></i></span>
        </div>
        <input type="password" class="form-control" placeholder="Senha" formControlName="password">
      </div>
      <div class="alert alert-danger m-0 mt-2 p-1" *ngIf="!!error">{{ error }}</div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" [disabled]="formulario.invalid" (click)="request($event)">OK</button>
    <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">Cancelar</button>
  </div>
</div>
